import React from 'react';
import QuickStart from '../../components/quick-start/QuickStart';
import useQuickHooks from './quickHooks';

const Quick: React.FC = () => {
    const {
        quickStartHooks,
        suffixText,
    } = useQuickHooks();

    return (
        <div className="paddle-install-page-subcontainer">
            <div className="paddle-context-h2" />

            <QuickStart trackeventOptLabel="开始使用" {...quickStartHooks} />
            <div className="paddle-install-quick-suffixtext" {...{ dangerouslySetInnerHTML: { __html: suffixText } }} />
        </div>

    );
};

export default Quick;
